import { getResolvedApiUrl } from '../apis/utils/provider';

const DEV_API_URL_LIST = ['https://api.eu-north-1.dev.cosafe.com'];
export const SUPPORT_APP_UPDATE_URL = 'https://redirect.cosafe.com/app-update';
export const SUPPORT_URL = 'https://support.cosafe.com';
export const INSTALL_DESKTOP_APP_URL =
  'https://support.cosafe.com/docs/handbook/users/get-started/install-cosafe/#install-cosafe-on-a-computer';

export const API_VERSION = 5;

export const isDevRelease = (): boolean => {
  const isDevUrl = DEV_API_URL_LIST.includes(getResolvedApiUrl());
  const isLocal = window.location.host.includes('localhost');

  return !isLocal && isDevUrl;
};
